import { forwardRef, useState } from "react";
import styled from "styled-components";

const FloatingInputWrapper = styled.div`
  position: relative;
  margin: 8px 0px;
  > input {
    border: 1px solid #ececec;
    border-radius: 10px;
    box-shadow: none;
    font-size: 16px;
    width: 100%;
    padding: 15px 20px 16px;
    height: 60px;
    cursor: ${(props) => props.cursor};
    border-color: ${(props) => (props.$error ? "#e74c3c" : "#ececec")};
    :focus {
      padding-top: 16px;
      padding-bottom: 6px;
      border-color: ${(props) => (props.$error ? "#e74c3c" : "#3bb77e")};
    }
    ${(props) =>
      props.value &&
      `padding-top: 16px;
      padding-bottom: 6px;
      border-color: ${(props) => (props.$error ? "#e74c3c" : "#3bb77e")};
    `}
  }
`;
const FloatingLabel = styled.label`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 16px 20px 16px;
  overflow: hidden;
  text-align: start;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
  border: 1px solid transparent;
  margin: 0px;
  opacity: 1;
  transform-origin: 0 0;
  transform: ${(props) =>
    props.focused || props.value
      ? `scale(0.8) translateY(-0.6rem) translateX(0.2rem)`
      : ""};
  transition: transform 0.2s ease-in-out;
`;

const Error = styled.span`
  margin-top: 10px;
  color: #e74c3c;
  font-size: 13px;
`;

const FloatingInput = (props) => {
  const {
    placeholder,
    value,
    onChange,
    readOnly,
    onClick,
    type,
    min,
    max,
    name,
    register,
    error,
  } = props;
  const [focused, setFocused] = useState(false);
  const handleFocus = () => setFocused(true);
  const handleBlur = () => setFocused(false);

  return (
    <>
      <FloatingInputWrapper
        onClick={() => onClick && onClick()}
        cursor={onClick ? "pointer" : "auto"}
        $error={error}
        value={value}
      >
        <FloatingLabel htmlFor="input" focused={focused} value={value}>
          {placeholder}
        </FloatingLabel>
        {register ? (
          <input
            id="input"
            name={name}
            type={"text"}
            onFocus={handleFocus}
            readOnly={readOnly}
            min={min || ""}
            value={value}
            {...register(name)}
            onBlur={handleBlur}
          />
        ) : (
          <input
            id="input"
            type={type || "text"}
            onFocus={handleFocus}
            onBlur={handleBlur}
            value={value || ""}
            onChange={onChange}
            readOnly={readOnly}
            min={min || ""}
          />
        )}
        {error && <Error>{error.message}</Error>}
      </FloatingInputWrapper>
    </>
  );
};
export default FloatingInput;
